import React, {ReactNode, useEffect, useRef} from 'react'
import EEGSummaryBrain3DAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryBrain3dAPI'
import EEGSummaryLobeAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryLobeAPI'
import EEGSummaryOpinionAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryOpnionAPI'
import RoiComponentAPI from 'components/molcules/Report/RoiComponentAPI'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/ProfitSummaryReport/useStyles'
import {Lobe, Roi} from 'api/analysisApi'

interface EEGSummaryProps {
  contourImage?: string
  threeDimensionImage: string
  total: number
  CustomerCard?: ReactNode
  reportType: ReportType
  isSummary?: boolean
  lobe: Lobe
  roi: Roi
}

export default function EEGSummaryAPI(props: EEGSummaryProps) {
  const {
    contourImage,
    threeDimensionImage,
    total,
    lobe,
    roi,
    CustomerCard,
    reportType,
    isSummary,
  } = props
  const classes = useStyles()
  const {textEegAPI} = useLanguage('eeg')

  const handleTop = () => {
    const scroll = document.getElementById('root')

    scroll?.scrollTo(0, 0)
  }

  useEffect(() => {
    handleTop()
  }, [])

  const refs = useRef<HTMLDivElement[]>([])
  useEffect(() => {
    if (textEegAPI?.footer) {
      textEegAPI.footer.forEach((item, index) => {
        if (refs.current[index]) {
          refs.current[index].innerHTML = item
        }
      })
    }
  }, [textEegAPI])

  return (
    <div className={classes.root}>
      {CustomerCard && CustomerCard}
      <EEGSummaryBrain3DAPI
        index={1}
        threeDimensionImage={threeDimensionImage}
        isSummary={isSummary}
      />
      {lobe !== null && lobe !== undefined && (
        <EEGSummaryLobeAPI index={2} lobe={lobe} isSummary={isSummary} />
      )}
      <EEGSummaryOpinionAPI
        index={3}
        score={total}
        contourImage={contourImage}
        isSummary={isSummary}
      />
      {lobe != null &&
        lobe !== undefined &&
        roi != null &&
        roi !== undefined &&
        reportType === 'P2' && <RoiComponentAPI roi={roi} lobe={lobe} />}
      <p className='Warning'>
        {textEegAPI?.footer.map((_, index) => (
          <div
            key={index}
            ref={(el) => {
              if (el) refs.current[index] = el
            }}
          />
        ))}
      </p>
    </div>
  )
}
